import { getContainerData } from '../container/container-utils';
import { getParentContextName } from '../utils/context-utils';
import constants from '../constants';
import { ACTION_SHOWVIEW } from '../store/state/actions';

import RouteParser from './route-parser';

/**
 * this function helps to build target name
 * @ignore
 * @param target -- container target name
 * @param baseContext -- base context
 * @returns -- new target name
 */
export const getResolvedTargetName = (target: string, baseContext?: string | null): string | null => {
  if (!target || !baseContext) {
    return null;
  }
  let newTargetContainerName: string | null = constants.EMPTY_STRING;
  let isTargetContainerPresent;
  if (baseContext) {
    newTargetContainerName = `${baseContext}${constants.FORWARD_SLASH_STRING}${target}`;
    isTargetContainerPresent = getContainerData(newTargetContainerName);

    if (!isTargetContainerPresent && !baseContext.includes('/')) {
      newTargetContainerName = `${baseContext}${constants.FORWARD_SLASH_STRING}${target}`;
    } else if (!isTargetContainerPresent) {
      newTargetContainerName = getResolvedTargetName(target, getParentContextName(baseContext));
    }
  }
  return newTargetContainerName;
};

/**
 * this function helps to get Routing Info for the passed in Target and Context Name
 * @ignore
 * @param target -- container target name
 * @param context -- base context
 * @returns -- routing info state object
 */
export const getRoutingInfo = (target: string, context: string) => {
  const resolvedTarget = getResolvedTargetName(target, context);
  if (resolvedTarget && getContainerData(resolvedTarget)) {
    return getContainerData(resolvedTarget);
  }
  return {};
};

/**
 * Retrieve semantic URL by view name and view class for showView container action
 * @ignore
 * @param viewName - view name
 * @param queryParameters - query params
 * @returns semantic url or empty string
 * @public
 */
export const getSemanticURLFromRoutingInfo = (viewName: string, queryParameters: any) => {
  return RouteParser.getSemanticURL(ACTION_SHOWVIEW, { page: viewName }, queryParameters);
};
